import { Form, Input, Button, Card, message } from 'antd';
import { resetPasswordAPI } from '../api/auth.api';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';

export default function ResetPassword() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const token = searchParams.get('token');
    if (token) {
      // could prefill or keep token in form hidden field
      form.setFieldsValue({ token });
    }
  }, []);

  const onFinish = async (values: any) => {
    try {
      const token = values.token;
      await resetPasswordAPI(token, values.password);
      message.success('Password updated. Redirecting to login...');
      setTimeout(() => navigate('/login'), 1000);
    } catch (err: any) {
      message.error(err.response?.data?.error || 'Failed to reset password');
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', backgroundColor: '#f5f5f5' }}>
      <Card style={{ width: 420 }} title={<h3 style={{ margin: 0 }}>Reset Password</h3>}>
        <Form form={form} layout="vertical" onFinish={onFinish} initialValues={{ token: searchParams.get('token') || '' }}>
          <Form.Item name="token" style={{ display: 'none' }}>
            <Input />
          </Form.Item>

          <Form.Item name="password" label="New Password" rules={[{ required: true, message: 'Enter a new password' }, { min: 6, message: 'Password must be at least 6 characters' }]}>
            <Input.Password size="large" />
          </Form.Item>

          <Form.Item name="confirm" label="Confirm Password" dependencies={["password"]} rules={[{ required: true, message: 'Confirm your password' }, ({ getFieldValue }) => ({ validator(_, value) { if (!value || getFieldValue('password') === value) { return Promise.resolve(); } return Promise.reject(new Error('Passwords do not match')); } })]}>
            <Input.Password size="large" />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block size="large">Update Password</Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}
